import {
    CREATE_THEME,
    CREATE_THEME_IN_QUIZ_SUCCESS,
    CREATE_THEME_IN_CALENDAR_SUCCESS,
    UPDATE_THEME,
    UPDATE_THEME_IN_QUIZ_SUCCESS,
    UPDATE_THEME_IN_CALENDAR_SUCCESS,
    DELETE_THEME,
    DELETE_THEME_IN_QUIZ_SUCCESS,
    DELETE_THEME_IN_CALENDAR_SUCCESS
} from './constants.js';

/**
 *
 * @param widget
 * @returns {{widget: *, type: string}}
 */
const createTheme = ( widget ) => ( { type: CREATE_THEME, widget } );
/**
 *
 * @param theme
 * @param widget
 * @returns {{theme: *, type: string}}
 */
const createThemeSuccess = ( theme, widget ) => ( {
    type: widget === 'quiz' ? CREATE_THEME_IN_QUIZ_SUCCESS : CREATE_THEME_IN_CALENDAR_SUCCESS,
    theme
} );
/**
 *
 * @param themePartValue
 * @param themePart
 * @param id
 * @param widget
 * @returns {{widget: *, themePartValue: *, themePart: *, id: *, type: string}}
 */
const updateTheme = ( themePartValue, themePart, id, widget ) => ( {
    type: UPDATE_THEME,
    themePartValue,
    themePart,
    id,
    widget
} );
/**
 *
 * @param theme
 * @param widget
 * @returns {{widget: *, theme: *, type: string}}
 */
const updateThemeSuccess = ( theme, widget ) => ( {
    type: widget === 'quiz' ? UPDATE_THEME_IN_QUIZ_SUCCESS : UPDATE_THEME_IN_CALENDAR_SUCCESS,
    theme,
    widget
} );
/**
 *
 * @param id
 * @param widget
 * @returns {{widget: *, id: *, type: string}}
 */
const deleteTheme = ( id, widget ) => ( {
    type: DELETE_THEME,
    id,
    widget
} );
/**
 *
 * @param themes
 * @param widget
 * @param deletedID
 * @returns {{themes: *, deletedID: *, type: string}}
 */
const deleteThemeSuccess = ( themes, widget, deletedID ) => ( {
    type: widget === 'quiz' ? DELETE_THEME_IN_QUIZ_SUCCESS : DELETE_THEME_IN_CALENDAR_SUCCESS,
    themes,
    deletedID
} );

export {
    createTheme,
    createThemeSuccess,
    updateTheme,
    updateThemeSuccess,
    deleteTheme,
    deleteThemeSuccess,
};